import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import NavigationLinks from './navigation-links'
import * as styles from '../footer/footer.module.scss'

const MenuFooterGlobal = () => {
  const data = useStaticQuery(graphql`
    {
      menu: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "navigation-top-footer-bottom" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
    }
  `)
  const navigationLinks =
    data?.menu?.nodes[0].navigationItems[0].navigationLinks

  return (
    <nav className={`${styles.menuPrefooter} col pb-3`}>
      <NavigationLinks items={navigationLinks} showDescription={false} />
    </nav>
  )
}

export default MenuFooterGlobal
